import { ReactText } from 'react'

export const removeSpaceFromNumber = (number: ReactText) => {
	return String(number).split(' ').join('')
}
